// extracted by mini-css-extract-plugin
module.exports = {"table":"OrderCompleteSummary_table__1Y5hz","uppercase":"OrderCompleteSummary_uppercase__3xHsa"};